module.exports = __webpack_public_path__ + "img/top2.8e9dde72.png";